import cloneDeep from 'lodash/cloneDeep';
import Group from '@/classes/v2/Group';

const currentUserGroups = state => {
  return cloneDeep(state.currentUserGroups).sort(Group.compare) || [];
};

const enterpriseGroups = state => {
  return cloneDeep(state.enterpriseGroups).sort(Group.compare) || [];
};

const allGroups = state => {
  return cloneDeep([...state.currentUserGroups, ...state.enterpriseGroups])
    .sort(Group.compare);
};

const getGroupByName = state => groupName => {
  const allGroups = [...state.currentUserGroups, ...state.enterpriseGroups];
  return cloneDeep(
    allGroups.find(group => group.groupName.toLowerCase().trim() === groupName.toLowerCase().trim())
  );
};

const findGroupsIncludingContact = state => (searchString = '') => {
  return cloneDeep([...state.currentUserGroups, ...state.enterpriseGroups])
    .filter(group => searchString ? group.filteredContacts(searchString).length : true)
    .sort(Group.compare);
};

export default {
  allGroups,
  currentUserGroups,
  enterpriseGroups,
  getGroupByName,
  findGroupsIncludingContact
};
